import { useContext } from "react";
import { Box, Stack, Typography, Grid } from "@mui/material";
import { AuthContext } from "../../../Context/AuthContext";
export default function AttendanceHeader({ tableData }) {
  // Change Language
  const { t } = useContext(AuthContext);

  const header = [
    {
      label: t("thead_present"),
      value: tableData?.totalPresent,
      color: "green",
    },
    {
      label: t("thead_late"),
      value: tableData?.totalLate,
      color: "orange",
    },
    {
      label: t("thead_permission"),
      value: tableData?.totalPermission,
      color: "blue",
    },
    {
      label: t("thead_absent"),
      value: tableData?.totalAbsent,
      color: "red",
    },
    {
      label: t("thead_female"),
      value: tableData?.totalFemale,
      color: "gray",
    },
    {
      label: t("thead_total_student"),
      value: tableData?.totalStudent,
      color: "#131870",
    },
  ];

  return (
    <Grid container spacing={2}>
      {header?.map((e, index) => (
        <Grid item xs={3} sm={3} md={2} lg={2} xl={2} key={index}>
          <Stack>
            <Typography
              className={t("class-name-text-field-title")}
              sx={{ color: "#131870", paddingX: "14px" }}
            >
              {e?.label}
            </Typography>
            <Box
              sx={{
                padding: "8px 14px",
                bgcolor: "white",
                borderRadius: 1,
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography sx={{ fontWeight: "bold", color: e?.color }}>
                  {e?.value}
                </Typography>
                <Typography sx={{ color: "#131870" }}>pax</Typography>
              </Stack>
            </Box>
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
}
